import axios from '@axios'

export default {
  namespaced: true,
  state: {
    items: [],
  },
  getters: {
    getItems(state) {
      return state.items
    },
    getSelectedItems(state) {
      return state.items.map(master_tenant => ({
        value: master_tenant.id,
        label: master_tenant.name,
      }))
    },
    getSelectedItemsTag(state) {
      return state.items.map(tag => ({
        value: tag.id,
        label: tag.tag,
      }))
    },
  },
  mutations: {
    setData(state, value) {
      state.items = value
    },
  },
  actions: {
    async getAll({ commit }, params) {
      const { data } = await axios.get('v1/request_tag', { params })

      if (!data.success) {
        return []
      }

      commit('setData', data.data)
      return data
    },
    async add(_, params) {
      const { data } = await axios.post('v1/request_tag', params)

      return data
    },
    async edit(_, { id, params }) {
      const { data } = await axios.put(`v1/request_tag/${id}`, params)

      return data
    },
    async delete(_, id) {
      const { data } = await axios.delete(`v1/request_tag/${id}`)

      return data
    },
    clear({ commit }) {
      commit('setData', [])
    }
  },
}
